export default __webpack_public_path__ + "static/media/amex-logo.788cf452.svg";